import React from 'react'
import Map from '../components/Map'

export default function Dashboard() {
  return (
    <Map />
  )
}
